import React, { useState } from "react";
import Modal from "react-modal";
import PriceForm from "./PriceForm";

Modal.setAppElement("#root");

const PriceOptions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);

  function toggleModalOne() {
    setIsOpen(!isOpen);
  }
  function toggleModalTwo() {
    setIsOpen2(!isOpen2);
  }
  function toggleModalThree() {
    setIsOpen3(!isOpen3);
  }

  return (
    <div className="shane_tm_section" id="prices">
      <div className="shane_tm_news">
        <div className="container">
          <div className="shane_tm_title">
            <h3>Prices & Rates</h3>
          </div>
          {/* End shane_tm_title */}
          <div className="news_list">
            <ul>
              <li data-aos="fade-up" data-aos-duration="1200">
                <div className="list_inner">
                  <div className="image" onClick={toggleModalOne}>
                    <img src="/img/placeholders/4-3.jpg" alt="thumb" />
                    <div
                      className="main"
                      style={{
                        backgroundImage: `url(${
                          process.env.PUBLIC_URL + "img/prices/cut-out-prices.jpg"
                        })`,
                      }}
                    ></div>
                  </div>
                  {/* End image */}

                  <div className="details">
                    <h3 className="title" onClick={toggleModalOne}>
                      Per Item Cut Outs
                    </h3>
                  </div>
                  {/* End details */}

                  {/* START MODAL */}
                  <Modal
                    isOpen={isOpen}
                    onRequestClose={toggleModalOne}
                    contentLabel="My dialog"
                    className="custom-modal"
                    overlayClassName="custom-overlay"
                    closeTimeoutMS={500}
                  >
                    <div className="shane_tm_modalbox_news">
                      <button className="close-modal" onClick={toggleModalOne}>
                        <img src="/img/svg/cancel.svg" alt="close icon" />
                      </button>
                      {/* End close icon */}
                      <div className="box_inner">
                        <div className="description_wrap scrollable">
                          <div className="image">
                            <img src="/img/placeholders/4-3.jpg" alt="thumb" />
                            <div
                              className="main"
                              style={{
                                backgroundImage: `url(${
                                  process.env.PUBLIC_URL +
                                  "img/prices/cut-out-prices.jpg"
                                })`,
                              }}
                            ></div>
                          </div>
                          {/* End image */}
                          <h3 className="title">Per Image Price Calculator</h3>

                          <div className="description">
                            <p>
                              The prices listed below are for standard items of clothing and accessories,
                              finished as cut out images on a
                              pure white background (#ffffff). Some garments,
                              such as halter-neck and strappy tops require
                              multiple images and take additional time in post
                              production. These are priced accordingly. Please
                              ask for a quote.
                            </p>
                            <p>
                              All prices exclude VAT, which will be added at the standard rate.
                            </p>
                            <p>
                              There is a fixed handling and processing charge of
                              £32 for each order. Delivery and return is NOT
                              included in this fee.
                            </p>
                            <p>
                              The first image of each item is priced as follows:
                            </p>
                            <div className="pricinglist">
                              <ul>
                                <li>
                                  The first 1 to 5 items are priced at £23 each
                                </li>
                                <li>The next 5 items at £20.50 each</li>
                                <li>The next 10 items at £18.50 each</li>
                                <li>Further items at at £16.50 each</li>
                                <br></br>
                                <li>
                                  {" "}
                                  Additional cutout images of the same item, for
                                  example back views are £13 per image.{" "}
                                </li>
                                <li>
                                  {" "}
                                  Detail shots, that are NOT cut out, are £13 for
                                  a set of up to 3 images of the same item.
                                </li>
                              </ul>
                            </div>
                            <p>
                              <br></br>
                              Please use the pricing calculator below or contact
                              me if you have more complex requirements.
                            </p>

                            <p>
                              <b> Jewellery</b> - Prices are
                              calculated by time used, time based rates apply. Please get in touch with your
                              requirements and I can provide an estimate.&nbsp;
                            
                            </p>
                          </div>
                          <div className="details">
                            <PriceForm />
                          </div>
                          <div className="tc-linkprices">
                              <a href="img/resume/Terms-and-Conditions.pdf"
                                download
                              >
                               Terms & Conditions can be downloaded here.{" "}
                              </a>
                             
                              </div>
                          {/* End description */}
                        </div>
                      </div>
                      {/* End box inner */}
                    </div>

                    {/* End modal box news */}
                  </Modal>
                  {/* End modal */}
                </div>
              </li>
              {/* End single blog */}

              <li
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="150"
              >
                <div className="list_inner">
                  <div className="image" onClick={toggleModalTwo}>
                    <img src="/img/placeholders/4-3.jpg" alt="thumb" />
                    <div
                      className="main"
                      style={{
                        backgroundImage: `url(${
                          process.env.PUBLIC_URL +
                          "img/prices/beauty-1000-670.jpg"
                        })`,
                      }}
                    ></div>
                  </div>
                  {/* End image */}

                  <div className="details">
                    <h3 className="title" onClick={toggleModalTwo}>
                    Time Based Rates
                    </h3>
                  </div>
                  {/* End details */}

                  <Modal
                    isOpen={isOpen2}
                    onRequestClose={toggleModalTwo}
                    contentLabel="My dialog"
                    className="custom-modal"
                    overlayClassName="custom-overlay"
                    closeTimeoutMS={500}
                  >
                    <div className="shane_tm_modalbox_news">
                      <button className="close-modal" onClick={toggleModalTwo}>
                        <img src="/img/svg/cancel.svg" alt="close icon" />
                      </button>
                      {/* End close modal */}
                      <div className="box_inner">
                        <div className="description_wrap scrollable">
                          <div className="image">
                            <img
                              src="/img/placeholders/beauty-1000-670.jpg"
                              alt="thumb"
                            />
                            <div
                              className="main"
                              style={{
                                backgroundImage: `url(${
                                  process.env.PUBLIC_URL +
                                  "img/prices/beauty-1000-670.jpg"
                                })`,
                              }}
                            ></div>
                          </div>
                          {/* End image */}
                          <div className="details">
                            <h3 className="title">Time Based Rates</h3>
                          </div>
                          {/* End details */}
                          <div className="description">
                            <p>
                            These prices are for a single job or batch. The use of standard equipment is included.
                            </p>
                            <p>
                              All prices exclude VAT, which will be added at the standard rate.
                            </p>
                            <div className="pricinglist">
                              <ul>
                                <li>
                                  First 16 hours <b>£85 per hour</b>
                                </li>
                                <li>
                                  Hours 17+ <b>£75 per hour</b>
                                </li>
                                <li>
                                  Pre-production - Set building, props sourcing etc. <b>£85 per hour</b>
                                </li>
                              </ul>
                              <ul>
                                <li>
                                  Location fee <b>£205</b>
                                </li>
                                <li>
                                Studio fee - Only for client or model attented shoots <b>£205</b>
                                </li>
                              </ul>
                            </div>
                            <br></br>
                            <p>
                              Example 1: Job total 8 hours, comprising 6 hours of photography and 2 hours processing would be £205 + (8x £85) = £885.
                              <br></br>
                              Example 2: Job total 2 hours, comprising 1.5 hour location shoot of photography and 1/2 hour processing would be £205 + (2x £85) = £375.
                            </p>
                            <p>
                              Please get in contact with your requirements for an 
                              estimate, as the number of items or shots achieved will depend on the brief.
                            </p>
                            <br></br>
                          </div>
                          <div className="tc-link">
                            <a
                              href="img/resume/Terms-and-Conditions.pdf"
                              download
                            >
                              Terms & Conditions can be downloaded here.{" "}
                            </a>
                          </div>
                          {/* End description */}

                          {/* End news share */}
                        </div>
                      </div>
                    </div>
                  </Modal>
                  {/* End modal */}
                </div>
                {/* End list inner */}
              </li>
              {/* End single blog */}

              <li
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="300"
              >
                <div className="list_inner">
                  <div className="image" onClick={toggleModalThree}>
                    <img
                      src="/img/placeholders/4-3.jpg"
                      alt="hand bag on pink background"
                    />
                    <div
                      className="main"
                      style={{
                        backgroundImage: `url(${
                          process.env.PUBLIC_URL +
                          "img/prices/bag-red.jpg"
                        })`,
                      }}
                    ></div>
                  </div>
                  {/* END IMAGE */}

                  <div className="details">
                    <h3 className="title" onClick={toggleModalThree}>
                    Creative Images
                    </h3>
                  </div>
                  {/* END DETAILS */}

                  {/* START MODAL */}
                  <Modal
                    isOpen={isOpen3}
                    onRequestClose={toggleModalThree}
                    contentLabel="My dialog"
                    className="custom-modal"
                    overlayClassName="custom-overlay"
                    closeTimeoutMS={500}
                  >
                    <div className="shane_tm_modalbox_news">
                      <button
                        className="close-modal"
                        onClick={toggleModalThree}
                      >
                        <img src="/img/svg/cancel.svg" alt="close icon" />
                      </button>
                      {/* END CLOSE MODAL */}
                      <div className="box_inner">
                        <div className="description_wrap scrollable">
                          <div className="image">
                            <img
                              src="/img/placeholders/bag-red.jpg"
                              alt="hand bag"
                            />
                            <div
                              className="main"
                              style={{
                                backgroundImage: `url(${
                                  process.env.PUBLIC_URL +
                                  "img/prices/bag-red.jpg"
                                })`,
                              }}
                            ></div>
                          </div>
                          {/* END IMAGE */}
                          <div className="details">
                            <h3 className="title">Jewellery, Creative Images, Video & AI</h3>
                          </div>
                          {/* END DETAILS */}
                          <div className="description">
                            <p>
                              Prices are for unattended shoots, for jewellery,
                              flat lays, stop motion, creative product stills, and video using
                              coloured backgrounds, props or special lighting
                              techniques the price is charged for the time used.
                              These prices also apply to computer based work such as retouching and AI asset creation.
                              </p> 
                              <p>
                              The time charged incudes the
                              whole 'job' i.e. preparation, set construction
                              and testing, set break down, packing up, processing and post production.
                            </p>
                            <p>
                              All prices exclude VAT, which will be added at the standard rate.
                            </p>
                            <div className="pricinglist">
                              <ul>
                                <li>First 16 hours <b>£85 per hour</b></li>
                                <li>Hours 17+ <b>£75 per hour</b></li>
                                <br></br>
                              </ul>
                            </div>
                            <div className="tc-link">
                              <a
                                href="img/resume/Terms-and-Conditions.pdf"
                                download
                              >
                                Terms & Conditions can be downloaded here.{" "}
                              </a>
                            </div>
                          </div>
                          {/* END DESCRIPTION */}
                        </div>
                      </div>
                    </div>
                  </Modal>
                </div>
                {/* END LIST INNER */}
              </li>

              {/* End single blog */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceOptions;
